export class ErrorModel {
  message: string;
  code?: string;
  disableToastErrorMessage?: boolean;
  errorCode?: string;
  generalMessage?: string;
  location?: string;
}
